export default function DataSourceService({ baseUrl, http }) {
  const PATH_LOGS = '/logs';
  const PATH_LOG = '/log';
  const PATH_USERS = '/users';
  const PATH_MESSAGE = '/message';
  const PATH_CONVERSATION = '/conversation';
  const PATH_CUSTOM_MESSAGE = '/custom_message';
  const PATH_FORMULARIOS = '/formularios';
  const PATH_MASIVOS = '/masivos';
  const PATH_PROFILE = '/profile';
  const PATH_TEMPLATES = '/templates';
  const PATH_TENANT_USERS = '/tenant/users';
  const PATH_DASHBOARD_SUMMARY = '/dashboard/summary';
  const PATH_FAQ_STATS = '/dashboard/faq-stats';
  // Nuevos endpoints para JWT
  const PATH_AUTH_TOKEN = '/auth/token';
  const PATH_AUTH_REFRESH = '/auth/token/refresh';
  const PATH_AUTH_REGISTER = '/auth/register';
  const PATH_SURVEYS = '/surveys';
  const PATH_SURVEY_RESPONSES = '/survey-responses';

  return {
    getLogs,
    getLogPayload,
    getUsers,
    getUserMessages,
    sendCustomMessage,
    getRespuestas,
    getMasivos,
    getProfile,
    loadUserRoles,
    getTemplates,
    getTenantUsers,
    createTenantUser,
    updateTenantUser,
    deleteTenantUser,
    getDashboardSummary,
    getFaqStats,
    updateUserProfile,
    login,
    refreshToken,
    register,
    getConversation,
    updateConversation,
    getSurveys,
    createSurvey,
    updateSurvey,
    deleteSurvey,
    getSurveyResponses,
  };

  function getLogs() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_LOGS}`
    });
  }

  function getLogPayload(id_log) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_LOG}`,
      query: { id_log }
    });
  }

  function getUsers(tenant_id, sucursal_id, conversation_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_USERS}`,
      query: { tenant_id, sucursal_id, conversation_id }
    });
  }

  function getUserMessages(user_id, tenant_id, sucursal_id, conversation_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_MESSAGE}`,
      query: { user_id, tenant_id, sucursal_id, conversation_id }
    });
  }

  function sendCustomMessage(body) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_CUSTOM_MESSAGE}`,
      body: body
    });
  }

  function getRespuestas(tenant_id, sucursal_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_FORMULARIOS}`,
      query: { tenant_id, sucursal_id }
    });
  }

  function getMasivos(tenant_id, sucursal_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_MASIVOS}`,
      query: { tenant_id, sucursal_id }
    });
  }

  function getProfile() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_PROFILE}`
    });
  }

  function loadUserRoles(profile) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_USERS}`,
      body: profile
    });
  }

  function getTemplates(tenant_id, sucursal_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_TEMPLATES}`,
      query: { tenant_id, sucursal_id }
    });
  }

  function getTenantUsers(tenant_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_TENANT_USERS}`,
      query: { tenant_id }
    });
  }

  function createTenantUser(userData) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_TENANT_USERS}`,
      body: userData
    });
  }

  function updateTenantUser(user_id, userData) {
    return http.putAuthenticated({
      url: `${baseUrl}${PATH_TENANT_USERS}`,
      query: { user_id },
      body: userData
    });
  }

  function deleteTenantUser(user_id, tenant_id) {
    return http.deleteAuthenticated({
      url: `${baseUrl}${PATH_TENANT_USERS}`,
      query: { user_id, tenant_id }
    });
  }

  function getDashboardSummary(params = {}) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_DASHBOARD_SUMMARY}`,
      query: params
    });
  }

  function getFaqStats(params = {}) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_FAQ_STATS}`,
      query: params
    });
  }

  function updateUserProfile(userData) {
    return http.putAuthenticated({
      url: `${baseUrl}${PATH_PROFILE}`,
      body: userData
    });
  }

  function login(credentials) {
    return http.post({
      url: `${baseUrl}${PATH_AUTH_TOKEN}`,
      body: credentials
    });
  }

  function refreshToken(refreshToken) {
    return http.post({
      url: `${baseUrl}${PATH_AUTH_REFRESH}`,
      body: { refresh: refreshToken }
    });
  }

  function register(userData) {
    return http.post({
      url: `${baseUrl}${PATH_AUTH_REGISTER}`,
      body: userData
    });
  }

  function getConversation(user_id, tenant_id, sucursal_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_CONVERSATION}`,
      query: { user_id, tenant_id, sucursal_id }
    });
  }

  function updateConversation(body) {
    return http.putAuthenticated({
      url: `${baseUrl}${PATH_CONVERSATION}`,
      body: body
    });
  }

  function getSurveys(tenant_id, sucursal_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_SURVEYS}`,
      query: { tenant_id, sucursal_id }
    });
  }

  function createSurvey(surveyData) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_SURVEYS}`,
      body: surveyData
    });
  }

  function updateSurvey(survey_id, surveyData) {
    return http.putAuthenticated({
      url: `${baseUrl}${PATH_SURVEYS}`,
      query: { survey_id },
      body: surveyData
    });
  }

  function deleteSurvey(survey_id) { 
    return http.deleteAuthenticated({
      url: `${baseUrl}${PATH_SURVEYS}`,
      query: { survey_id }
    });
  }

  function getSurveyResponses(survey_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_SURVEY_RESPONSES}`,
      query: { survey_id }
    });
  }
}
